import React from "react";
import PropTypes from 'prop-types';
import { liad_3 } from "../assets/images";
import AnimateOnScroll from '../components/AnimateOnScroll';
import { useLanguage } from '../providers/LanguageProvider';

const About = ({ id }) => {
  const { translations } = useLanguage();
  
  return (
  <section id={id} className="bg-charcoal py-12 md:py-20">
    {/* make the gap between the image and the text and the sides to be equal */}
    <div className="mx-auto flex max-w-[1220px] flex-col gap-20 px-6 lg:flex-row lg:items-stretch">
      <div className="flex-1">
      <AnimateOnScroll>
        <h3 className="text-2xl md:text-3xl text-sand font-bold text-center pb-4">{translations.about.title}</h3>
        <div className="border-t border-sand w-2/3 mx-auto" />
      </AnimateOnScroll>
        <AnimateOnScroll delay={300}>
          <div className="mt-4 text-center text-sand">
            <p className="text-lg md:text-xl whitespace-pre-line">{translations.about.intro}</p>
            <p className="mt-4 text-lg md:text-xl leading-8 whitespace-pre-line">{translations.about.experience}</p>
            <p className="mt-4 text-lg md:text-xl leading-8 whitespace-pre-line">{translations.about.approach}</p>
            <p className="mt-4 text-lg md:text-xl leading-8 whitespace-pre-line">{translations.about.goal}</p>
          </div>
        </AnimateOnScroll>
      </div>
      <div className="flex-1 lg:h-auto">
        <AnimateOnScroll className="h-full">
          <img
            src={liad_3}
            alt="Liad Dahari"
            className="h-full w-full rounded-md object-cover shadow-md"
          />
        </AnimateOnScroll>
      </div>
    </div>
  </section>
  );
};

About.propTypes = {
  id: PropTypes.string,
};

export default About;
